/* =========================================================
   Desert City Games — Cart Add-ons
   File: assets/dcg-cart-addons.js
   Version: 1.1 — 03 AUG 2026

   1. Initialises the add-ons owl-carousel with the SAME config as the
      product-page Related Products section (sections/relatedproductsblock.liquid)
      so it looks and behaves identically.
   2. Cards add to cart through the standard dcg-product-card flow (same as
      Related Products). On the cart page we then refresh the cart section in
      place so the newly added item appears without a full-page reload
      (scroll preserved — a win on mobile), and re-init the carousel.

   ── v1.1 — selector collision fix (F-CART-1) ───────────────────────────
   SECTION_SEL was '[data-section-type="cart-template"]'. That attribute is
   not unique: snippets/cart-dropdown.liquid:1 carries the identical one and
   is rendered from sections/header-top.liquid:359, which sits ABOVE the main
   content in layout/theme.liquid (header-nav at :472-474 vs :480-490).

   Every querySelector below therefore resolved to the HEADER CART DROPDOWN,
   not the cart line-item table:
     - `live`  was the dropdown, so `secId` was header-top's section id
     - the fetch requested /cart?section_id=header-top
     - `cur.replaceWith(fresh)` swapped the header dropdown for a fresh copy

   Net effect: adding an add-on never updated the cart table it was supposed
   to refresh, and silently replaced an unrelated piece of the header instead
   — which also orphaned the #_mobile_cart clone that shop.js:394-401 makes.

   Now targets `data-dcg-cart-section`, added to the cart section wrapper in
   sections/cart-template.liquid. The rest of refreshCartSection was already
   correct: the add-ons snippet renders INSIDE that wrapper (cart-template
   line ~254, nesting depth 2), so replacing it does legitimately re-render
   the carousel — which is why initCarousel(0) runs afterwards. The
   quick-view modal is deliberately rendered outside the wrapper so it
   survives the swap.

   NOTE: both files must ship together. This selector matches nothing until
   sections/cart-template.liquid carries the new attribute.
========================================================= */
(function () {
  "use strict";

  (window.DCG = window.DCG || {}).cartAddonsVersion = "1.1";

  var SECTION_SEL  = '[data-dcg-cart-section]';
  var CAROUSEL_SEL = ".dcg-cart-addons-carousel";

  function initCarousel(attempt) {
    attempt = attempt || 0;
    var $ = window.jQuery;
    if (!$ || !$.fn || typeof $.fn.owlCarousel !== "function") {
      if (attempt < 60) setTimeout(function () { initCarousel(attempt + 1); }, 150);
      return;
    }

    var $owl = $(CAROUSEL_SEL);
    if (!$owl.length) return;

    if ($owl.hasClass("owl-loaded")) {
      $owl.trigger("destroy.owl.carousel");
      $owl.find(".owl-stage-outer").children().unwrap();
      $owl.removeClass("owl-center owl-loaded owl-text-select-on");
    }

    $owl.owlCarousel({
      items: 4,
      nav: true,
      navText: ["<i class='material-icons'></i>", "<i class='material-icons'></i>"],
      dots: false,
      autoplay: false,
      rewind: true,
      loop: false,
      margin: 0,
      responsive: {
        0:    { items: 1 },
        544:  { items: 2 },
        768:  { items: 3 },
        992:  { items: 3 },
        1200: { items: 4 }
      },
      onInitialized: function () {
        if (typeof window.dcgInitProductCards === "function") window.dcgInitProductCards(document);
        if (typeof window.updateTabIndexes === "function") window.updateTabIndexes();
      },
      onTranslated: function () {
        if (typeof window.updateTabIndexes === "function") window.updateTabIndexes();
      }
    });
  }

  // Refresh the cart section in place via Shopify's Section Rendering API,
  // then re-init the add-ons carousel on the swapped-in markup.
  function refreshCartSection() {
    var live = document.querySelector(SECTION_SEL);
    if (!live) return;
    var secId = live.getAttribute("data-section-id");
    if (!secId) return;

    fetch(window.location.pathname + "?section_id=" + encodeURIComponent(secId), {
      headers: { Accept: "text/html" },
      credentials: "same-origin"
    })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fresh = doc.querySelector(SECTION_SEL);
        var cur = document.querySelector(SECTION_SEL);
        if (!fresh || !cur) return;
        cur.replaceWith(fresh);
        if (typeof window.adjustCartDropDown === "function") {
          try { window.adjustCartDropDown(); } catch (_) {}
        }
        initCarousel(0);
      })
      .catch(function () {});
  }

  // Adding an add-on card dispatches cart:updated (via DCG.cart.addItem).
  // Refresh the cart list to reflect it. Guarded so a burst of events only
  // triggers one refresh.
  var refreshing = false;
  document.addEventListener("cart:updated", function () {
    if (refreshing) return;
    refreshing = true;
    setTimeout(function () { refreshing = false; }, 800);
    refreshCartSection();
  });

  function boot() { initCarousel(0); }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (e) {
    if (e.target && e.target.querySelector(CAROUSEL_SEL)) initCarousel(0);
  });
})();
